import React, { useState } from "react";
import { publish } from '../../../utils/pubsubWrapper';
import { Form, Button, Row, Col } from "react-bootstrap";
import { Input } from "../../shared";
import { getAlphabetFromIndex } from '../../../utils/utils'
import { DeleteIcon } from "../../../utils/FontIcon";

export default function AddOptions({ question, qindex }) {
    const [questionText, setQuestionText] = useState(question?.questionText || '');
    const [questionType, setQuestionType] = useState(question?.type);
    const [errors, setErrors] = useState({});
    const [options, setOptions] = useState(() => {
        question?.options.map((opt, idx) => {
            opt.index = idx;
            return opt;
        });
        return question?.options || [];
    });
    const handelOptionChgange = (e) => {
        const { name, value } = e.target;
        let options = [];
        setQuestionType(value);
        if (value == 'TrueFalse') {
            options = [{
                text: '',
                explanation: '',
                isCorrect: false,
                index: 0
            }, {
                text: '',
                explanation: '',
                isCorrect: false,
                index: 1
            }]
        } else {
            options = [{
                text: '',
                explanation: '',
                isCorrect: false,
                index: 0
            }, {
                text: '',
                explanation: '',
                isCorrect: false,
                index: 1
            }, {
                text: '',
                explanation: '',
                isCorrect: false,
                index: 2
            }, {
                text: '',
                explanation: '',
                isCorrect: false,
                index: 3
            }]
        }
        setOptions(options);
        setErrors({});
    }
    const handelAddOption = () => {
        const optionlength = options.length;
        if (!questionType.trim()) {
            setErrors((prev) => ({ ...prev, questionType: 'Question type is required.' }));
        } else if ((questionType == 'MSQ' || questionType == 'MCQ' || questionType == 'FIB')) {
            if (optionlength < OptionLimit) {
                let tempOption = [...options];
                tempOption.push({
                    text: '',
                    explanation: '',
                    isCorrect: false,
                    index: optionlength
                })
                setOptions(tempOption);
                setErrors((prev) => ({ ...prev, questionType: '' }));
            } else {
                console.log(`you can not add more then ${OptionLimit} options`)
            }

        } else if (questionType == 'TrueFalse') {
            if (optionlength < OptionLimit) {
                let tempOption = [...options];
                tempOption.push({
                    text: '',
                    explanation: '',
                    isCorrect: false,
                    index: optionlength
                })
                setOptions(tempOption);
                setErrors((prev) => ({ ...prev, questionType: '' }));
            } else {
                console.log(`you can not add more then ${OptionLimit} options`)
            }
        }
    }
    const resetOption = (tempOption, rightindex) => {
        return tempOption.map((option, index) => {
            if (rightindex == index) {
                option.isCorrect = true;
            } else {
                option.isCorrect = false;
            }
            return option;
        })
    }
    const handleChange = (e, index, valueKey) => {
        const { type, name, value } = e.target;
        let tempOption = [...options];
        if (type === 'radio') {
            tempOption = resetOption(tempOption, index)
        } else if (type === 'checkbox') {
            console.log('e.target.checked:::', e.target.checked)
            if (e.target.checked) {
                tempOption[index][valueKey] = true;
            } else {
                tempOption[index][valueKey] = false;
            }
        } else {
            tempOption[index][valueKey] = value;
        }
        setOptions(tempOption);
        setErrors((prev) => ({ ...prev, [`optionText${index}`]: '' }));
    };
    const validate = () => {
        const newErrors = {};
        options.forEach((option, index) => {
            if (!option.text.trim()) {
                newErrors[`optionText${index}`] = `Option text is required.`;
            }
            // if (!option.explanation.trim()) {
            //     newErrors[`explanation${index}`] = `Explanation for Option is required.`;
            // }
        });
        if (!questionText.trim()) {
            newErrors.question = "Question text is required.";
        }
        if (!questionType.trim()) {
            newErrors.questionType = "Question type is required.";
        }
        if (!options.some(opt => opt.isCorrect)) {
            newErrors.correct = "At least one correct option must be selected.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (validationErrors) {
            publish('SAVE_OPTIONS', {
                questionText,
                questionType,
                options,
                qindex
            });
        }
    };

    const handelDeleteOption = (indexToDelete) => {
        let tempOptions = [...options]
        tempOptions.splice(indexToDelete, 1);
        setOptions(tempOptions);
    }
    const OptionLimit = questionType == 'TrueFalse' ? 2 : 6;
    const handleChangeQuestion = (e) => {
        const { name, value } = e.target;
        setQuestionText(value);
        setErrors((prev) => ({ ...prev, question: '' }));
    };
    return (
        <Row>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col lg={9} className="pb-3 fw-semibold">
                        <Input
                            label="Question"
                            isMandetory={true}
                            name="question"
                            value={questionText}
                            onChange={handleChangeQuestion}
                            placeholder="Type your question"
                            isInvalid={!!errors.question}
                            feedback={errors.question}
                            inlineFeedback={true}
                        />
                        {/* <span className="fw-bold">Question:</span>{question?.questionText} */}
                    </Col>
                    <Col lg={3}>
                        <Input
                            label="Question Type"
                            type="select"
                            name="questionType"
                            value={questionType}
                            onChange={handelOptionChgange}
                            isInvalid={!!errors.questionType}
                            feedback={errors.questionType}
                            multiple={false}
                            options={[
                                { value: 'MSQ', label: 'Multi Select Question' },
                                { value: 'MCQ', label: 'Multi Choice Question' },
                                { value: 'TrueFalse', label: 'True/False' },
                                { value: 'FIB', label: 'Fill-in-the-Blanks' }
                            ]}
                            isMandetory={true}
                            inlineFeedback={true}
                        />
                    </Col>
                    <Col lg={12}><hr style={{ margin: '0px 0px 10px 0px' }}></hr></Col>
                    <Col lg={12}>
                        {/* sete header for options */}
                        {options.length ? <Row style={{ marginBottom: '1.5rem' }}>
                            <Col lg={1}><small><strong style={{ lineHeight: '10px' }}>Choose </strong></small></Col>
                            <Col lg={6}><small><strong>Options</strong></small></Col>
                            <Col lg={4}><small><strong>Explaination</strong></small></Col>
                            <Col lg={1}><small><strong>Action</strong></small></Col>
                        </Row> : null}
                        {/* set options with checkbox or radio based on question type */}
                        {options.length ? options.map((option, index) => {
                            return <Row key={index} className="d-flex align-items-baseline">
                                <Col lg={1} className="d-flex justify-content-center">
                                    <Form.Check
                                        name="optionradio"
                                        type={questionType === 'MSQ' ? 'checkbox' : "radio"}
                                        style={{ width: '1.25rem', height: '1.25rem' }}
                                        checked={option.isCorrect}
                                        onChange={(e) => {
                                            setErrors((prev) => ({ ...prev, 'correct': '' }));
                                            handleChange(e, index, 'isCorrect')
                                        }}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Input
                                        label={`Option ${getAlphabetFromIndex(index)}`}
                                        isMandetory={true}
                                        name="option"
                                        value={option.text}
                                        onChange={(e) => {
                                            handleChange(e, index, 'text')
                                        }}
                                        placeholder="Option text will come here"
                                        isInvalid={!!errors[`optionText${index}`]}
                                        feedback={errors[`optionText${index}`]}
                                        inlineFeedback={true}
                                    />
                                </Col>
                                <Col lg={4}>
                                    <Input
                                        label={`Explanation (Option ${getAlphabetFromIndex(index)})`}
                                        isMandetory={false}
                                        name="explanationa"
                                        value={option.explanation}
                                        onChange={(e) => {
                                            handleChange(e, index, 'explanation')
                                        }}
                                        placeholder="enter explanation here"
                                    />
                                </Col>
                                <Col lg={1}>
                                    <a
                                        style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
                                        onClick={(e) => handelDeleteOption(index)}
                                        title={'Delete'}>
                                        <DeleteIcon />
                                    </a>
                                </Col>
                            </Row>
                        }) : null}
                        <small className="text-danger">{errors.correct}</small>
                        {/* add option button will show if options are less then option limit based on question type */}
                        {options.length && options.length < OptionLimit ?
                            <Row>
                                <Col lg={1}>
                                </Col>
                                <Col lg={10} className="p-3 border text-center btn add-option-btn" onClick={handelAddOption}>+ Add Option</Col>
                                <Col lg={1}>
                                </Col>
                            </Row> : null}

                    </Col>
                    {options.length ? <Col lg={12} className="my-2 d-flex justify-content-center">
                        <Button variant="outline-primary purle-btn" type="submit" className="px-4 purple-btn" style={{ width: '220px' }} >Proceed</Button>
                    </Col> : null}
                </Row>
            </Form>
        </Row>
    );
}